import React, { useState } from "react";
import "./index.css";
import { Formik } from "formik";
import styled from "styled-components";
import { PrimaryCTAButton } from "../../common/Buttons";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import { FormLabel } from "@material-ui/core";
import { CustomInputField } from "../../common/FormInputs";

const Index = () => {
  const [inputs] = useState([
    {
      name: "fullname",
      label: "Full Name",
      type: "text",
      placeholder: `Enter Your Full name`,
    },
    {
      name: "email",
      label: "Email ID",
      type: "email",
      placeholder: `Enter Your Email ID`,
    },
    {
      name: "companyName",
      label: "Company Name",
      type: "text",
      placeholder: `Enter Your Company name`,
    },
    {
      name: "location",
      label: "Location",
      type: "text",
      placeholder: `Enter Your Location`,
    },
  ]);

  return (
    <Background>
      <Container className="middle-center">
        <Formik
          initialValues={{
            enableRegistration: true,
            sendMailRegistration: false,
            enableLogin: true,
            userAllowedInsideConference: false,
            enablePassword: true,
            labelOutside: true,
            labelOne: "",
            noOfInput: 3,
          }}
          enableReinitialize
          onSubmit={""}
          validationSchema={""}
          validateOnBlur
          validateOnChange
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            setFieldValue,
            handleSubmit,
            handleChange,
          }) => (
            <form onSubmit={handleSubmit}>
              {inputs.map((input, index) => {
                return (
                  // <FormField
                  //   key={index}
                  //   {...{
                  //     touched,
                  //     errors,
                  //     input,
                  //     values,
                  //     handleChange,
                  //     handleBlur,
                  //     setFieldValue,
                  //   }}
                  // />
                  <div
                    className="form-fields"
                    style={{ width: "100%", paddingTop: 5 }}
                  >
                    <FormLabel
                      error={errors[input.name] && touched[input.name]}
                      style={{
                        fontFamily: theme.fonts.primaryFontSemiBold,
                        fontSize: 13,
                        color: COLORS.COLOR_DARK,
                      }}
                    >
                      {input.label}
                    </FormLabel>
                    <CustomInputField
                      className="input-white"
                      variant="outlined"
                      value={values[input.name]}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </div>
                );
              })}
            </form>
          )}
        </Formik>
        <div style={{ textAlign: "center" }}>
          <TnC>
            By clicking on the button below, you agree to terms of use of your
            information
          </TnC>
          <PrimaryCTAButton style={{ width: "auto", marginTop: "10px" }}>
            Submit
          </PrimaryCTAButton>
        </div>
      </Container>
    </Background>
  );
};

export default Index;

const Background = styled.div`
  background-image: linear-gradient(
    to bottom right,
    #00000022,
    #00000088
  ); /* Replace with your image URL */
  background-size: cover; /* Cover the entire background */
  background-position: center; /* Center the image */
  background-repeat: no-repeat;
  height: 100vh; /* Full viewport height */
  display: flex;
`;

const Container = styled.div`
  position: absolute;
  width: 380px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  top: 50%;
  transform: translateY(-50%);
  &.start-center {
    left: 10%;
  }
  &.middle-center {
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &.end-center {
    right: 10%;
  }
`;

const TnC = styled.div`
  margin-top: 10px;
  justify-content: left;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.COLOR_DARK};
`;
